import type { ErpModule } from '@/api/platform.api';
import { moduleAdminPath } from '@/config/moduleDefaults';
import { getSettingsRouteForLegacyPath, SETTINGS_PATH } from '@/config/settingsRegistry';

/** Map legacy org-wide or module-scoped admin URLs to canonical settings routes. */
export function legacyOrgAdminRedirectTarget(
  pathname: string,
  module: ErpModule,
): string | null {
  const settingsTarget = getSettingsRouteForLegacyPath(pathname);
  if (settingsTarget) return settingsTarget;

  if (pathname === '/org/administration' || pathname.startsWith('/org/administration/')) {
    if (pathname === '/org/administration/billing') {
      return getSettingsRouteForLegacyPath(moduleAdminPath(module, 'subscription')) ?? SETTINGS_PATH;
    }
    return SETTINGS_PATH;
  }
  if (pathname === '/org/profile' || pathname.startsWith('/org/profile/')) {
    return getSettingsRouteForLegacyPath(moduleAdminPath(module, 'organization')) ?? SETTINGS_PATH;
  }
  if (pathname === '/org/employees' || pathname.startsWith('/org/employees/')) {
    return getSettingsRouteForLegacyPath(moduleAdminPath(module, 'users')) ?? SETTINGS_PATH;
  }
  if (pathname === '/org/roles' || pathname.startsWith('/org/roles/')) {
    return getSettingsRouteForLegacyPath(moduleAdminPath(module, 'roles')) ?? SETTINGS_PATH;
  }
  if (pathname === '/org/subscription' || pathname.startsWith('/org/subscription/')) {
    return getSettingsRouteForLegacyPath(moduleAdminPath(module, 'subscription')) ?? SETTINGS_PATH;
  }
  if (pathname === '/org/workspace/subscription' || pathname.startsWith('/org/workspace/subscription')) {
    return getSettingsRouteForLegacyPath(moduleAdminPath(module, 'subscription')) ?? SETTINGS_PATH;
  }
  if (pathname === '/org/workspace/settings' || pathname.startsWith('/org/workspace/settings')) {
    return `${moduleAdminPath(module, 'profile')}?section=preferences`;
  }
  if (pathname === '/org/settings' || pathname.startsWith('/org/settings/')) {
    return `${moduleAdminPath(module, 'profile')}?section=preferences`;
  }
  return null;
}
